export const BOT_CHANNEL_ID = "d60ef9ff-91f3-5137-9d87-4e819af8efef";
